import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    blurryBlobRoot: {
        position: 'fixed',
        top: 0,
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 816,
        height: 816,
        borderRadius: '50%',
        background: '#E0D8D5',
        filter: 'blur(200px)',
        zIndex: 0,
        opacity: 0.7,
        pointerEvents: 'none',
    },
});

const BlurryBlobBackground = () => {
    const classes = useStyles();
    return <div className={classes.blurryBlobRoot} />;
};

export default BlurryBlobBackground;
